import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class SalesReportService {

  constructor(private _http: HttpClient, private _toastrService: ToastrService) { }

  getuserDropDown(): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}user-dropdown`, { })
      .pipe(
        map(data => {
          return data;
        })
      );
  }
  getAllData(formdata: any): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}sales-report`,formdata)
      .pipe(
        map(data => {
          return data;
        })
      );
  }
  fileDownload(formdata: any): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}export-sales-report`,formdata)
      .pipe(
        map(data => {
          return data;
        })
      );
  }
}
